var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 25,
    viewBox: "0 0 260 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1631L13.9972 5.70503V10.415L6.46791 15.125L13.9972 19.6359V24.6112L0 16.319V14.1631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8847 0.165844L27.2531 18.276L33.5551 0.165844H38.3646L29.4422 23.7157H25.0308L16.0752 0.165844H20.8847Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2304 19.7023V23.7157H40.8782V0.165844H56.9319V4.17927H45.4555V9.85113H55.373V13.566H45.4555V19.7023H57.2304Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7989 23.7157V0.165844H65.3762V19.7023H77.3833V23.7157H60.7989Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.169 23.7157V0.165844H84.7462V19.7023H96.7533V23.7157H80.169Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.071 23.8815C107.346 23.8815 105.776 23.5498 104.361 22.8865C102.968 22.2231 101.763 21.3275 100.746 20.1998C99.7505 19.0499 98.9765 17.7674 98.4237 16.3522C97.8709 14.9149 97.5945 13.4444 97.5945 11.9408C97.5945 10.3708 97.8819 8.87818 98.4569 7.46298C99.0539 6.02566 99.861 4.75419 100.878 3.64857C101.917 2.52083 103.134 1.63633 104.527 0.995063C105.942 0.331688 107.49 0 109.17 0C110.873 0 112.421 0.342744 113.814 1.02823C115.229 1.71372 116.434 2.63139 117.429 3.78124C118.424 4.93109 119.198 6.21362 119.751 7.62882C120.304 9.04402 120.58 10.5034 120.58 12.0071C120.58 13.555 120.293 15.0476 119.718 16.4849C119.143 17.9001 118.336 19.1716 117.297 20.2993C116.28 21.4049 115.063 22.2784 113.648 22.9196C112.255 23.5609 110.729 23.8815 109.071 23.8815ZM102.238 11.9408C102.238 12.9579 102.393 13.9419 102.702 14.8928C103.012 15.8436 103.454 16.695 104.029 17.4468C104.626 18.1765 105.345 18.7625 106.185 19.2047C107.048 19.6249 108.021 19.8349 109.104 19.8349C110.21 19.8349 111.194 19.6138 112.056 19.1716C112.918 18.7072 113.637 18.0991 114.212 17.3473C114.787 16.5733 115.218 15.722 115.506 14.7933C115.815 13.8424 115.97 12.8916 115.97 11.9408C115.97 10.9236 115.804 9.95064 115.472 9.02191C115.163 8.07107 114.71 7.23079 114.113 6.50108C113.538 5.74926 112.819 5.16327 111.957 4.74314C111.116 4.30089 110.165 4.07976 109.104 4.07976C107.976 4.07976 106.981 4.31194 106.119 4.7763C105.279 5.21856 104.571 5.81559 103.996 6.56742C103.421 7.31925 102.979 8.15952 102.669 9.08825C102.382 10.017 102.238 10.9678 102.238 11.9408Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.152 0.232182H136.397L139.084 8.02685L141.804 0.232182H146.016L141.97 10.9457L144.955 18.4418L151.622 0.165844H156.597L147.177 23.7157H143.23L139.084 13.8314L134.971 23.7157H131.024L121.637 0.165844H126.546L133.246 18.4418L136.165 10.9457L132.152 0.232182Z",
    fill: "url(#paint0_linear_34_71)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.411 0.165844H170.055L178.712 23.7157H174.002L171.813 17.8448H163.587L161.431 23.7157H156.721L165.411 0.165844ZM170.984 14.6274L167.733 4.90898L164.35 14.6274H170.984Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.295 23.7157V0.165844H191.71C192.793 0.165844 193.788 0.386969 194.695 0.829219C195.624 1.27147 196.42 1.86851 197.083 2.62033C197.769 3.37216 198.288 4.21244 198.642 5.14116C199.018 6.06989 199.206 7.02073 199.206 7.99368C199.206 8.98874 199.029 9.95064 198.675 10.8794C198.344 11.786 197.857 12.582 197.216 13.2675C196.575 13.953 195.823 14.4837 194.96 14.8596L200.334 23.7157H195.292L190.449 15.8215H185.872V23.7157H181.295ZM185.872 11.8081H191.61C192.185 11.8081 192.694 11.6422 193.136 11.3106C193.578 10.9568 193.932 10.4924 194.198 9.91747C194.463 9.34254 194.596 8.70128 194.596 7.99368C194.596 7.24185 194.441 6.58953 194.131 6.03672C193.822 5.46179 193.424 5.00849 192.937 4.6768C192.473 4.34511 191.964 4.17927 191.411 4.17927H185.872V11.8081Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219.706 19.7023V23.7157H203.353V0.165844H219.407V4.17927H207.931V9.85113H217.848V13.566H207.931V19.7023H219.706Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.076 0.165844L226.624 23.7157H221.715L238.134 0.165844H243.076Z",
    fill: "url(#paint1_linear_34_71)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260 16.319L246.003 24.6112V19.6359L253.532 15.125L246.003 10.415V5.70503L260 14.1631V16.319Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_71",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 24.6112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A19A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A19A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_71",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 24.6112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A19A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C034E3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a5b0fc7b7a1b6d27ac157159bb075aaf.svg";
export { ForwardRef as ReactComponent };